'use es6';

import { get } from '../../common/objutils';
export function patchSdkPath(path) {
  if (get(path, '[0]') === 'oauth') {
    return ['auth', ...path];
  }
  return path;
}